import React, { useState } from 'react';
import '../styles/theme.css';
import '../styles/TrackShipment.css';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import TrackShipmentCustodyHistory from '../components/TrackShipmentCustodyHistory';
import TrackShipmentLookup from '../components/TrackShipmentLookup';
/* IMPORTS */

function TrackShipmentPage() {
  const [shipmentId, setShipmentId] = useState('');

  return (
    <div className="tr-root">
      <div id="trackshipmentnavbar" className="tr-slot-trackshipmentnavbar">
        <Navbar activePage={"Track Shipment"} />
      </div>
      <div id="trackshipmentlookup" className="tr-slot-trackshipmentlookup">
        <TrackShipmentLookup onShipmentResolved={setShipmentId} />
      </div>
      <div id="trackshipmentcustodyhistory" className="tr-slot-trackshipmentcustodyhistory">
        <TrackShipmentCustodyHistory shipmentId={shipmentId} />
      </div>
      <div id="trackshipmentfooter" className="tr-slot-trackshipmentfooter">
        <Footer />
      </div>
    </div>
  );
}

export default TrackShipmentPage;